<template>
    <QualificationField
        :title="$t('profile.vetting.qualification.availability.title')"
        :field-author-and-date="qualification.commentOnAvailability"
        data-testid="admin-section-tabs-qualification-availability"
    >
        <VJoyWrapper no-margin v-bind="{align: 'stretch', direction: 'column', rowGap: '4'}">
            <VJoyTextarea
                v-if="profileQualificationStore.inEditMode"
                v-model="profileQualificationStore.qualificationUpdateForm.commentOnAvailability"
                :placeholder="$t('profile.vetting.qualification.availability.comment.placeholder')"
                autogrow
                data-testid="vetting-availability-comment-edition"
            ></VJoyTextarea>
            <TextField
                v-else
                truncate
                :content="profileQualificationStore.qualificationUpdateForm.commentOnAvailability"
                :replace-by="$t('profile.vetting.qualification.availability.comment.empty.placeholder')"
                data-testid="vetting-availability-comment"
            />
            <VJoyCheckbox
                v-if="profileQualificationStore.inEditMode"
                :checked="profileQualificationStore.qualificationUpdateForm.noLongerAvailableDueToPermanentEmployment"
                :label="$t('profile.vetting.qualification.availability.no.longer.available.label')"
                data-testid="vetting-availability-no-longer-available-edition"
                @update:checked="(value) => (profileQualificationStore.qualificationUpdateForm.noLongerAvailableDueToPermanentEmployment = value)"
            />
            <VJoyBadge
                v-else-if="showNoLongerAvailableText"
                data-testid="vetting-availability-no-longer-available"
                variant="yellow"
                :label="$t('profile.vetting.qualification.availability.no.longer.available.text')"
            />
        </VJoyWrapper>
    </QualificationField>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {VJoyBadge, VJoyWrapper, VJoyCheckbox, VJoyTextarea} from '@maltjoy/core-vue';
    import TextField from '~/components/admin-section-tabs/qualification/TextField.vue';
    import {useProfileQualificationStore} from '~/store/profileQualificationStore';
    import QualificationField from './ui/QualificationField.vue';

    const profileQualificationStore = useProfileQualificationStore();

    const {qualification} = storeToRefs(profileQualificationStore);

    const showNoLongerAvailableText = computed(
        () => !profileQualificationStore.inEditMode && profileQualificationStore.qualificationUpdateForm.noLongerAvailableDueToPermanentEmployment,
    );
</script>
